<div *ngIf="formType === creationTextType.WEB">
  <form [formGroup]="typingForm">
    <div class="form-textarea">
      <label for="" class="textarea-label d-flex justify-content-between">
        <span>
          {{typingLabel}}
        </span>
        <span class="fnt-size10px">
          {{typingForm.value?.typing?.length ? typingForm.value?.typing?.length : 0}}/{{maxLength}}
        </span>
      </label>
      <textarea #typingInput [maxlength]="maxLength" class="text-area-height-web textarea-field form-control bg-white" [ngClass]=""
        [placeholder]="typingPlaceholder" formControlName="typing"
        (input)="onTypingChange($event.target.value)" (click)="onFocus()">
      </textarea>
    </div>
  </form>
</div>

<div class="console-texting p-3" *ngIf="formType === creationTextType.M_WEB">
  <div class="console-texting-icons d-flex justify-content-between mx-2">
    <img class="cursor-pointer" src="assets/images/cross-dark.svg" alt="icon" width="32" height="32"
      (click)="cancelTyping()">
    <img class="cursor-pointer" src="assets/images/trash.svg" alt="icon" width="32" height="32"
      (click)="this.isTypingDeleteModal = true;">
  </div>
  <form [formGroup]="typingForm" (ngSubmit)="onSubmitTyping()">
    <div class="text-center">
      <textarea #typingInput [maxlength]="maxLength"
        class="text-area-height text-center form-control bg-transparent border-0 text-white"
        [placeholder]="typingPlaceholder" formControlName="typing" autofocus (click)="onFocus()">
    </textarea>
    </div>
    <button [ngClass]="{'btn-secondary': !typingForm.valid, 'btn-success': typingForm.valid}"
      class="console-texting-btn btn-design medium fillded btn" [disabled]="!typingForm.valid" type="submit">
      {{buttonText}}
    </button>
  </form>
</div>
<app-delete-modal *ngIf="formType === creationTextType.M_WEB" [headingText]="deletePopupHeading + '?'"
  [paragraphText]="deletePopupParagraph+'?'" [cancelButtonText]="deletePopupCancelText" [deleteButtonText]="deletePopupDeleteText"
  [isDeleteModal]="isTypingDeleteModal" (emitOnHidden)="isTypingDeleteModal = false"
  (emitOnDelete)="emitDeleteEvent()">
</app-delete-modal>
